import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "@/services/axiosAuth";
import { CASH_APP } from "./apiRoutes";

const mutateAddCashApp = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${CASH_APP(data?.communityId)}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const useAddCashAppMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddCashApp,
    ...queryParams,
  });

export default useAddCashAppMutation;
